import { LoadableAfterPaint } from '@confluence/loadable';

export const CopyPageDialog = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-CopyPageContainer" */ './CopyPageDialogContainer.tsx'))
			.CopyPageDialogContainer,
});
